export default __webpack_public_path__ + "static/media/chrome.607c0628.png";